module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-5.79c17e85.jpg";